/**
 * Press Tabs Section with Desktop Tabs and Mobile Slider
 * - Desktop: Tab interface with logo navigation
 * - Mobile: Auto slider OR column layout based on setting
 */

window.initPressTabsSlider = function (container) {
  const slider = container.querySelector('.press-tabs__slider');
  const mobileLayout = container.dataset.mobileLayout; 

  if (!slider || typeof Splide === 'undefined' || mobileLayout !== 'slider') {
    return null;
  }

  let splideInstance = null;

  const isMobile = () => window.innerWidth < 768;

  const mountSlider = () => {
    if (!isMobile() || splideInstance) return;

    const autoplay = container.dataset.sliderAutoplay === 'true';

    splideInstance = new Splide(slider, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 30,
      arrows: false,
      pagination: false,
      drag: true,
      autoplay: autoplay,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: 800,
      easing: 'ease',
      direction: 'ltr',
      trimSpace: false,
      focus: 0,
      updateOnMove: true,
      i18n: {
        carousel: 'Press mentions carousel',
        slide: 'press item',
        slideLabel: '%s of %s',
      }
    });

    splideInstance.mount();
    container.splideInstance = splideInstance;
  };

  const destroySlider = () => {
    if (splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
      container.splideInstance = null;
    }
  };

  const handleResize = () => {
    if (isMobile()) {
      mountSlider();
    } else {
      destroySlider();
    }
  };

  // Initial mount
  handleResize();

  // Handle window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 150);
  });

  return splideInstance;
};

class PressTabs {
  constructor(container) { 
    this.container = container;
    this.tabs = container.querySelectorAll('.press-tabs__tab');
    this.panels = container.querySelectorAll('.press-tabs__panel');
    
    this.init();
  }

  init() {
    // Initialize desktop tabs if they exist
    if (this.tabs.length > 0 && this.panels.length > 0) {
      this.initTabs();
    }

    // Initialize mobile slider
    window.initPressTabsSlider(this.container);
  }

  initTabs() {
    // Add click listeners to tabs
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.switchTab(index));
      
      // Keyboard navigation
      tab.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  switchTab(index) {
    // Deactivate all tabs and panels
    this.tabs.forEach(tab => {
      tab.classList.remove('press-tabs__tab--active');
      tab.setAttribute('aria-selected', 'false');
    });
    
    this.panels.forEach(panel => {
      panel.classList.remove('press-tabs__panel--active');
    });

    // Activate selected tab and panel
    this.tabs[index].classList.add('press-tabs__tab--active');
    this.tabs[index].setAttribute('aria-selected', 'true');
    
    this.panels[index].classList.add('press-tabs__panel--active');
  }

  handleKeydown(e, currentIndex) {
    let newIndex = currentIndex;

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        newIndex = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        break;
      case 'ArrowRight':
        e.preventDefault();
        newIndex = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        break;
      case 'Home':
        e.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    this.tabs[newIndex].focus();
    this.switchTab(newIndex);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const pressTabsSections = document.querySelectorAll('.press-tabs');
  pressTabsSections.forEach(section => new PressTabs(section));
});

// Initialize on Shopify theme editor section load
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.press-tabs');
    if (section) {
      new PressTabs(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('.press-tabs');
    if (container && container.splideInstance) {
      container.splideInstance.destroy();
    }
  });
}

